import { Directive, ElementRef, Input, OnChanges, inject } from '@angular/core';

@Directive({
  selector: '[scrollOnMe]',
  standalone: true,
})
export class ScrollOnMeDirective implements OnChanges {
  @Input('scrollOnMe') scrollEnabled: boolean;

  private readonly htmlElement: HTMLElement;

  constructor() {
    const hostElement = inject(ElementRef);

    this.htmlElement = hostElement.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges<this>): void {
    if (changes.scrollEnabled && this.scrollEnabled) {
      setTimeout(() => this.htmlElement.scrollIntoView({ block: 'center' }));
    }
  }
}
